<div class="container" style="height: 100%">

        <table *ngIf="!showAddGroupKeyTable" id="button-table">
                <col width="95%">
                <col width="5">
                <tr>
                        <td style="border: none;">
                                <div class="col-2">
                                        <button class="btn btn-sm btn-outline-secondary" (click)="processFPTables()">
                                                Process Reporting Tables
                                        </button>
                                </div>
                        </td>
                        <td style="border: none;">

                                <div class="action-buttons" ngbTooltip="Add New Member">

                                        <a (click)="addGroupKey()">
                                                <i class="fa fa-plus" style="color: green"></i>
                                        </a>
                                </div>

                        </td>
                </tr>

        </table>

        <div>
                <app-add-group-key *ngIf="showAddGroupKeyTable" (hide)="hideAddNewGroupKey()"
                        (save)="saveNewGroupKey($event)">
                </app-add-group-key>
        </div>

        <hr />
        <div id="results" class="row">
                <div class="col-12 position-relative">

                        <tcc-table tableClass="table-sm small" [rows]="fpGroupRows" [columns]="fpGroupColumns"
                                [buttons]="(fpRequestsButtons) ? fpRequestsButtons : undefined"
                                (cellClick)="fpGroupClicked($event)" (sortChange)="getResults()">
                        </tcc-table>
                </div>
        </div>

</div>

<tcc-loadingOverlay *ngIf="state !== 'ready'"></tcc-loadingOverlay>